import React from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'

const EditMappings = ({ selectedDtcs, sid, filters }) => {
  const navigate = useNavigate()

  const goToPosts = () => {
    navigate({
      pathname: `/vehicles/${sid}/dtcs/listing/mappings`,
      search: `?${createSearchParams({ dtc_id: selectedDtcs.map((dtc) => dtc.id) })}`,
    })
  }

  return (
    <a
      onClick={(e) =>
        selectedDtcs.length < 1 ? e.preventDefault() : goToPosts()
      }
      className="btn"
    >
      Edit Mappings for {selectedDtcs.length} DTCs
    </a>
  )
}

EditMappings.propTypes = {}

export default EditMappings
